<template>
  <div class="box">
    <el-form :model="info" label-position="left" :rules="rules" ref="ruleForm" label-width="160px" class="ruleForm" size="small">
<!--      <el-form-item label="订单运费">-->
<!--        <el-input v-model="info.order_fee" placeholder="输入金额">-->
<!--          <template slot="append">元</template>-->
<!--        </el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="腾讯地图key">
        <el-input v-model="info.qq_map_key" placeholder="输入key"></el-input>
      </el-form-item>
      <el-form-item label="会员邀请锁定时间">
        <el-input v-model="info.invite_member_lock_day" placeholder="输入锁定天数">
          <template slot="append">天，超过N天就归新的邀请人</template>
        </el-input>
      </el-form-item>
<!--      <el-form-item label="自动收货天数">-->
<!--        <el-input v-model="info.confirm_receipt_days" placeholder="输入天数">-->
<!--          <template slot="append">天，发货后超过当前天数，自动帮用户确认收货</template>-->
<!--        </el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="业绩兑换时间">
        <el-input v-model="info.refund_over_days" placeholder="输入天数">
          <template slot="append">天，发货开始计算：当前时间内订单可退款</template>
        </el-input>
      </el-form-item>
      <el-form-item label="授权店邀请授权店/分公司">
        <el-input v-model="info.store_invite_lv" placeholder="输入百分比">
          <template slot="append">% 得授权店门槛金额的百分比</template>
        </el-input>
      </el-form-item>
      <el-form-item label="授权店邀请升级分公司">
        <el-form-item label="邀请授权店/分公司数量">
          <el-input v-model="info.store_upgrade_company_invite_sum" placeholder="输入数量">
            <template slot="append">个起</template>
          </el-input>
        </el-form-item>
        <el-form-item label="每个门店消费完成订单金额">
          <el-input v-model="info.store_upgrade_company_finish_amount" placeholder="输入金额">
            <template slot="append">元起</template>
          </el-input>
        </el-form-item>
      </el-form-item>
      <el-form-item label="分公司邀请授权店">
        <el-form-item labelt="成为授权店">
          <el-input v-model="info.company_invite_store_lv" placeholder="输入百分比">
            <template slot="append">% 得授权店金额的百分比</template>
          </el-input>
        </el-form-item>
<!--        <el-form-item label="下级授权店充值（没用）">-->
<!--          <el-input v-model="info.company_invite_store_level_lv" placeholder="输入百分比">-->
<!--            <template slot="append">%</template>-->
<!--          </el-input>-->
<!--        </el-form-item>-->
      </el-form-item>
      <el-form-item label="分公司邀请分公司">
        <el-form-item label="成为分公司">
          <el-input v-model="info.company_invite_company_lv" placeholder="输入百分比">
            <template slot="append">% 得分公司金额的百分比</template>
          </el-input>
        </el-form-item>
        <el-form-item label="复冲提成">
          <el-input v-model="info.company_invite_company_rechage_lv" placeholder="输入百分比">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="下下级成为分公司">
          <el-input v-model="info.company_invite_company2_lv" placeholder="输入百分比">
            <template slot="append">% 得分公司金额的百分比</template>
          </el-input>
        </el-form-item>
        <el-form-item label="下下级复冲提成">
          <el-input v-model="info.company_invite_company2_rechage_lv" placeholder="输入百分比">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form-item>
      <el-form-item label="授权店折扣差价">
        <el-form-item label="上级分公司">
          <el-input v-model="info.discount_diff_first" placeholder="输入百分比">
            <template slot="append">% 得分公司和授权店折扣金额的百分比</template>
          </el-input>
        </el-form-item>
        <el-form-item label="上上级分公司">
          <el-input v-model="info.discount_diff_second" placeholder="输入百分比">
            <template slot="append">% 得分公司和授权店折扣金额的百分比</template>
          </el-input>
        </el-form-item>
      </el-form-item>
<!--      <el-form-item label="提现方式" prop="withdraw">-->
<!--        <el-checkbox-group v-model="info.withdraw">-->
<!--          <el-checkbox :label="1">微信</el-checkbox>-->
<!--          <el-checkbox :label="2">支付宝</el-checkbox>-->
<!--          <el-checkbox :label="3">银行卡</el-checkbox>-->
<!--        </el-checkbox-group>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="提现手续费">-->
<!--        <el-input v-model="info.withdraw_fee" placeholder="输入手续费">-->
<!--          <template slot="append">%</template>-->
<!--        </el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="最低提现金额">-->
<!--        <el-input v-model="info.withdraw_min" placeholder="输入金额">-->
<!--          <template slot="append">元</template>-->
<!--        </el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="充值规则" prop="recharge_rule">-->
<!--        <wang-edit :txt="info.recharge_rule" :callback="setText"></wang-edit>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="视频密码" prop="video_pwd">-->
<!--        <el-input v-model="info.video_pwd" placeholder="输入密码"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
// import WangEdit from "@/components/WangEdit";
  export default {
    data() {
      return {
        info: {
          invite_member_lock_day: '',
          confirm_receipt_days: '',
          refund_over_days: '',
          store_invite_lv: '',
          company_invite_store_lv: '',
          company_invite_store_level_lv: '',
          company_invite_company_lv: '',
          company_invite_company_rechage_lv: '',
          qq_map_key: '',
          store_upgrade_company_invite_sum: '',
          store_upgrade_company_finish_amount: '',
          company_invite_company2_lv: '',
          company_invite_company2_rechage_lv: '',
          discount_diff_first: '',
          discount_diff_second: '',
        },
        source_domain: this.config.SOURCE_DOMAIN,
        rules: {
        }
      };
    },
    created() {
      this.getInfo()
    },
    mounted() {
    },
    components: {
      // WangEdit
    },
    computed: {
    },
    methods: {
      setText(txt) {
        this.info.recharge_rule = txt
      },
      getInfo() {
        var that = this
        this.$api.merchant.sysDetail( function (res) {
          if(res.errcode == 0) {
            that.info = res.data
          }
        })
      },
      submitForm(formName) {
        var that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var param = that.info
            this.$api.merchant.sysEdit(param,function (res) {
              if(res.errcode == 0) {
                that.success(res.errmsg)
              } else {
                that.fail(res.errmsg)
              }
            })
          } else {
            return false;
          }
        });
      },
    }
  };
</script>
<style scoped>
  .box {
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;
    min-height: 500px;
  }
</style>
